import { connectedStore } from '../../store';
import getInterruptions from '../selectors/interruptions';
import getInterruptionPoint from '../helpers/get-interruption-point';

const findFor = (action) => {
  const matcher = getInterruptionPoint(action.type);

  if (!matcher) {
    return [];
  }

  const store = connectedStore.get();
  const state = store.getState();
  const interruptions = getInterruptions(state);
  const events = [];

  interruptions.forEach((interruption) => {
    const data = matcher(interruption, action);
    if (data) {
      events.push({
        action: interruption.action,
        options: interruption.options,
        data,
      });
    }
  });
  return events;
};

export default findFor;
